<mat-accordion class="expantion-style">
    <mat-expansion-panel class="mat-expansion-panel" [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="title">検索条件</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
            <div formGroupName="cndt">
                <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>作業年月日（開始）</mat-label>
                        <input matInput [matDatepicker]="workymdStart" formControlName="workymdStart"
                            autocomplete="off" maxlength="10" />
                        <mat-datepicker-toggle matSuffix [for]="workymdStart"></mat-datepicker-toggle>
                        <mat-datepicker #workymdStart [startAt]="workymdStart" id="workymdStart"></mat-datepicker>
                    </mat-form-field>
                    <span style="margin-left: 40px">～</span>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>作業年月日（終了）</mat-label>
                        <input matInput [matDatepicker]="workymdEnd" formControlName="workymdEnd" autocomplete="off" maxlength="10" />
                        <mat-datepicker-toggle matSuffix [for]="workymdEnd" id="workymdEnd"></mat-datepicker-toggle>
                        <mat-datepicker #workymdEnd [startAt]="workymdEnd"></mat-datepicker>
                    </mat-form-field>
                    <div class="flex flex-col justify-center items-start" style="padding-left: 20px;">
                        <mat-checkbox id="resultRegzumiFlg"
                            class="check-boxtw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]"
                            color="primary" formControlName="resultRegzumiFlg">完了／中止／延期／対象外分も表示
                        </mat-checkbox>
                    </div>
                </div>
            </div>
            <button type="submit" mat-raised-button color="primary" class="btn" id="search">検索</button>
            <button type="submit" style="margin-left: 1%;" [disabled]="" mat-raised-button color="primary" class="btn"
                id="today" (click)="resetForm()">当日分</button>
        </div>

    </mat-expansion-panel>
</mat-accordion>